
const NOTES_FREQ = [4186.01, 4434.92, 4698.63, 4978.03, 5274.04, 5587.65, 5919.91, 6271.93, 6644.88, 7040.00, 7458.62, 7902.13];
const NOTES_NAMES = ["do", "do#", "re", "re#", "mi", "fa", "fa#", "sol", "sol#", "la", "la#", "si"];
const NOTES_NAMES_EN = ["c", "c#", "d", "d#", "e", "f", "f#", "g", "g#", "a", "a#", "b"];

const NOTES: {
    name: string,
    freq: number,
    scale: number
}[] = [];


export const SEMI_NOTE_SIZE = Math.log2(NOTES_FREQ[1]) - Math.log2(NOTES_FREQ[0]);

export function getMaxNote() {
    const notes = getNotes();
    return notes[notes.length - 1].freq + SEMI_NOTE_SIZE;
}

export function getNoteFrequencyLog2(note: number) {

    return Math.log2(getNoteFrequency(note));
}

export function getNoteFrequency(note: number) {

    return getNotes()[note - 12].freq;
}

export function getNotes() {

    if (NOTES.length > 0)
        return NOTES;

    for (let i = 0; i <= 8; i++) {

        const pw = Math.pow(2, 8 - i);

        for (let j = 0; j < NOTES_FREQ.length; j++) {
            NOTES.push({
                name: NOTES_NAMES[j],
                freq: NOTES_FREQ[j] / pw,
                scale: i
            })
        }
    }

    return NOTES;
}